import React, { useState } from 'react';
import api from '../services/api';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await api.login(username, password);
      onLogin(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <div className="login-mobile-header">
          <span className="login-mobile-brand">Paras Foam Inventory Studio</span>
        </div>
        <div className="login-hero">
          <span className="login-eyebrow">Inventory Studio</span>
          <h1 className="login-title">
            🏭 Paras Foam
            <span>Inventory Studio</span>
          </h1>
          <p className="login-tagline">
            Track chemical movements with clarity. See levels, notes, and history at a glance.
          </p>
          <div className="hero-metrics">
            <div className="metric-chip">Fast entry</div>
            <div className="metric-chip">Reliable totals</div>
            <div className="metric-chip">Clear audit trail</div>
          </div>
          <div className="login-features">
            <div className="feature-card">
              <span className="feature-title">Live Stock View</span>
              <span className="feature-text">Instant visibility by chemical type.</span>
            </div>
            <div className="feature-card">
              <span className="feature-title">Smart Thresholds</span>
              <span className="feature-text">Color indicators keep low stock obvious.</span>
            </div>
            <div className="feature-card">
              <span className="feature-title">Audit Ready</span>
              <span className="feature-text">Every movement is dated and attributed.</span>
            </div>
          </div>
        </div>

        <div className="login-box">
          <h2>Welcome back</h2>
          <p className="login-subtitle">Sign in to manage inventory.</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter username"
                autoComplete="username"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter password"
                autoComplete="current-password"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
          <div className="login-help">
            <p>Need access? Ask your admin to create an account.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
